import type { GameState } from '../game';
import type { ActionResult } from './actions.types';

export const createCharacter = (state: GameState): ActionResult => {
  return {
    messages: [{ type: 'create-character' }],
    state,
  };
};
